import { ReducedIndividualPersonType } from "../../types/commonTypes/reducedIndividualPersonType";


export const initialReducedIndividualState : ReducedIndividualPersonType = {
    civility: "Monsieur",
    firstName: "",
    lastName: "" 
}